import { TagProps } from 'antd';
import { useThemeToken } from '@/hooks';
import { StyledTag } from './TagStyles';

type ITagProps = TagProps;

const Tag = (props: ITagProps) => {
  const token = useThemeToken();
  return <StyledTag {...props} $primaryColor={token.colorPrimary} />;
};

export default Tag;
